(() => {
  const PRIVACY_URL = '/search?q=lovalo-policy-privacy';
  const STYLE_ID = 'lovalo-compliance-styles';

  const addStyles = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .lovalo-consent-row{display:flex;align-items:flex-start;gap:10px;direction:rtl;text-align:right;margin-top:10px;color:inherit;font-size:12px;line-height:1.65;max-width:680px}
      .lovalo-consent-row input[type="checkbox"]{flex:0 0 auto;width:18px;height:18px;margin:2px 0 0;accent-color:#14233e;cursor:pointer}
      .lovalo-consent-row a,.lovalo-contact-privacy a{color:inherit;text-decoration:underline;text-underline-offset:3px;font-weight:700}
      .lovalo-consent-row a:focus-visible,.lovalo-contact-privacy a:focus-visible,.lovalo-consent-row input:focus-visible{outline:2px solid currentColor;outline-offset:3px}
      .lovalo-contact-privacy{direction:rtl;text-align:right;margin:2px 0 0;color:inherit;font-size:12px;line-height:1.7;opacity:.82;max-width:680px}
      @media(max-width:749px){.lovalo-consent-row,.lovalo-contact-privacy{font-size:11px;line-height:1.6}}
    `;
    document.head.appendChild(style);
  };

  const enhanceNewsletter = (form, index) => {
    if (!form || form.dataset.lovaloConsentEnhanced === 'true') return;
    const group = form.querySelector('.email-signup__input-group');
    const email = form.querySelector('input[type="email"][name="contact[email]"]');
    if (!group || !email) return;

    const consentId = `LovaloMarketingConsent-${index}`;
    const row = document.createElement('label');
    row.className = 'lovalo-consent-row';
    row.id = `${consentId}-description`;
    row.htmlFor = consentId;

    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.id = consentId;
    checkbox.name = 'contact[accepts_marketing]';
    checkbox.value = 'true';
    checkbox.required = true;
    checkbox.setAttribute('aria-required', 'true');

    const text = document.createElement('span');
    text.append('אני מאשר/ת לקבל מ־Lovalo עדכונים, הטבות ותוכן שיווקי בדוא״ל. ניתן להסיר את ההרשמה בכל עת. ');
    const link = document.createElement('a');
    link.href = PRIVACY_URL;
    link.textContent = 'מדיניות הפרטיות';
    text.appendChild(link);

    row.appendChild(checkbox);
    row.appendChild(text);
    group.insertAdjacentElement('afterend', row);

    const describedBy = (email.getAttribute('aria-describedby') || '').trim();
    email.setAttribute('aria-describedby', [describedBy, row.id].filter(Boolean).join(' '));
    form.dataset.lovaloConsentEnhanced = 'true';
  };

  const enhanceContact = (form, index) => {
    if (!form || form.dataset.lovaloPrivacyEnhanced === 'true') return;
    const email = form.querySelector('input[type="email"][name="contact[email]"]');
    const submit = form.querySelector('button[type="submit"]');
    if (!submit) return;

    if (email) {
      email.required = true;
      email.setAttribute('aria-required', 'true');
    }

    const existingConsent = form.querySelector('[data-lovalo-contact-consent]');
    if (existingConsent) {
      const checkbox = existingConsent.querySelector('input[type="checkbox"]');
      if (checkbox) {
        checkbox.required = true;
        checkbox.setAttribute('aria-required', 'true');
      }
      form.dataset.lovaloPrivacyEnhanced = 'true';
      return;
    }

    form.querySelectorAll('.contact-form__privacy-note, .lovalo-contact-privacy').forEach((node) => node.remove());

    const consentId = `LovaloContactPrivacyConsent-${index}`;
    const row = document.createElement('label');
    row.className = 'lovalo-consent-row';
    row.htmlFor = consentId;
    row.dataset.lovaloContactConsent = 'true';

    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.id = consentId;
    checkbox.name = 'contact[privacy_consent]';
    checkbox.value = 'מאושר';
    checkbox.required = true;
    checkbox.setAttribute('aria-required', 'true');

    const text = document.createElement('span');
    text.append('אני מאשר/ת ל־Lovalo להשתמש בפרטים שמסרתי לצורך טיפול בפנייה ומתן שירות, בהתאם ל־');
    const link = document.createElement('a');
    link.href = PRIVACY_URL;
    link.textContent = 'מדיניות הפרטיות';
    text.appendChild(link);
    text.append('.');

    row.appendChild(checkbox);
    row.appendChild(text);
    submit.insertAdjacentElement('beforebegin', row);

    if (email) {
      const describedBy = (email.getAttribute('aria-describedby') || '').trim();
      email.setAttribute('aria-describedby', [describedBy, consentId].filter(Boolean).join(' '));
    }

    form.dataset.lovaloPrivacyEnhanced = 'true';
  };

  const enhancePackageGroups = () => {
    document.querySelectorAll('.lp-packages[role="radiogroup"]').forEach((group) => {
      if (!group.hasAttribute('aria-label')) group.setAttribute('aria-label', 'בחירת חבילת רכישה');
      if (group.dataset.lovaloKeyboardEnhanced === 'true') return;
      const radios = Array.from(group.querySelectorAll('[role="radio"]'));
      if (!radios.length) return;
      radios.forEach((radio, index) => {
        radio.tabIndex = radio.getAttribute('aria-checked') === 'true' ? 0 : -1;
        radio.addEventListener('click', () => {
          radios.forEach((item) => { item.tabIndex = item === radio ? 0 : -1; });
        });
        radio.addEventListener('keydown', (event) => {
          if (!['ArrowRight','ArrowLeft','ArrowUp','ArrowDown'].includes(event.key)) return;
          event.preventDefault();
          const forward = event.key === 'ArrowLeft' || event.key === 'ArrowDown';
          const nextIndex = (index + (forward ? 1 : -1) + radios.length) % radios.length;
          const next = radios[nextIndex];
          next.focus();
          next.click();
        });
      });
      group.dataset.lovaloKeyboardEnhanced = 'true';
    });
  };

  const init = () => {
    addStyles();
    document.querySelectorAll('.email-signup__form').forEach((form, index) => enhanceNewsletter(form, index));
    document.querySelectorAll('.contact-form__form').forEach((form, index) => enhanceContact(form, index));
    enhancePackageGroups();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  const observer = new MutationObserver(() => init());
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
